import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getCart } from "@/features/cart/api/get-cart";
import type { Cart } from "@/features/cart/types/cart.type";

type UseGetCartParams = {
  params?: RequestInit;
  id: string;
  options?: Omit<
    UseQueryOptions<Cart, unknown, Cart, string[]>,
    "queryFn" | "queryKey"
  >;
};

export const useGetCart = ({ id, options }: UseGetCartParams) => {
  return useQuery({
    queryKey: ["cart", id],
    queryFn: () => getCart(id),
    ...options,
  });
};
